// Реализованные объекты (портфолио) с галереями фото.
// Фото лежат в /public/objects/<folder>/. Пути собираются с encodeURI (в именах есть пробелы).
// Площадь/срок частично оценочные — точных данных по части объектов нет.

const raw = [
  {
    folder: "first",
    title: "Вентиляция ВЗУ, г. Яхрома",
    category: "Коммерческий объект",
    type: "Вентиляция",
    area: "—",
    duration: "3 недели",
    summary:
      "Монтаж системы вентиляции водозаборного узла: приточно-вытяжная установка, воздуховоды и автоматика для стабильного микроклимата технического здания.",
    files: ["IMG_1375.JPG", "IMG_1376.JPG", "IMG_1377.JPG", "IMG_1378.JPG", "IMG_1379.JPG", "IMG_1380.JPG", "IMG_1381.JPG", "IMG_1382.JPG", "IMG_1383.JPG"],
  },
  {
    folder: "second",
    title: "Коттедж 180 м², г. Зарайск",
    category: "Коттедж",
    type: "Вентиляция",
    area: "180 м²",
    duration: "3 недели",
    summary:
      "Монтаж вентиляции в двухэтажном коттедже: разводка воздуховодов по этажам, приточно-вытяжная установка и настройка воздухообмена по всем помещениям.",
    files: ["IMG_1391 2.JPG", "IMG_1392 2.JPG", "IMG_1393 2.JPG", "IMG_1394 2.JPG", "IMG_1395 2.JPG", "IMG_1396 2.JPG", "IMG_1397 2.JPG", "IMG_1398 2.JPG", "IMG_1399 2.JPG"],
  },
  {
    folder: "third",
    title: "Окрасочная камера, г. Дубна («Энкор»)",
    category: "Производство",
    type: "Вентиляция",
    area: "—",
    duration: "4 недели",
    summary:
      "Вентиляция окрасочной камеры на производстве: приточно-вытяжная система с учётом технологических выделений, фильтрацией и нормами воздухообмена для покрасочных работ.",
    files: ["IMG_1400.JPG", "IMG_1401.JPG", "IMG_1402.JPG", "IMG_1403.JPG", "IMG_1404.JPG", "IMG_1405.JPG", "IMG_1406.JPG", "IMG_1407.JPG", "IMG_1408.JPG", "IMG_1409.JPG"],
  },
  {
    folder: "fourth",
    title: "Кондиционирование серверной",
    category: "Коммерческий объект",
    type: "Кондиционирование",
    area: "—",
    duration: "4 дня",
    summary:
      "Прецизионное кондиционирование серверной: подбор и монтаж системы охлаждения с запасом мощности для круглосуточной работы оборудования и поддержания стабильной температуры.",
    files: ["IMG_1410.JPG", "IMG_1411.JPG", "IMG_1412.JPG", "IMG_1413.JPG"],
  },
  {
    folder: "fifth",
    title: "Дом, д. Батюшково (Дмитровский р-н)",
    category: "Дом",
    type: "Естественная вентиляция",
    area: "—",
    duration: "1,5 недели",
    summary:
      "Монтаж естественной вентиляции жилого дома: организация каналов и вытяжки для постоянного воздухообмена без затрат на электроэнергию.",
    files: ["IMG_1414.JPG", "IMG_1415.JPG", "IMG_1416.JPG", "IMG_1417.JPG", "IMG_1418.JPG"],
  },
  {
    folder: "sixth",
    title: "Дом 200 м², д. Игнатовка (Дмитровский р-н)",
    category: "Дом",
    type: "Приточно-вытяжная вентиляция",
    area: "200 м²",
    duration: "3 недели",
    summary:
      "Приточно-вытяжная вентиляция дома 200 м²: установка с рекуперацией тепла, разводка воздуховодов и настройка комфортного микроклимата во всех комнатах.",
    files: ["IMG_1419.JPG", "IMG_1420.JPG", "IMG_1421 2.JPG", "IMG_1421.JPG", "IMG_1423.JPG", "IMG_1424.JPG", "IMG_1425.JPG"],
  },
  {
    folder: "seventh",
    title: "Коттедж 320 м², Яхрома Клаб",
    category: "Коттедж",
    type: "Вытяжная вентиляция",
    area: "320 м²",
    duration: "4 недели",
    summary:
      "Монтаж вытяжной вентиляции в коттедже 320 м²: система удаления отработанного воздуха из кухни, санузлов и технических помещений с тихой работой.",
    files: ["IMG_1426.JPG", "IMG_1427.JPG", "IMG_1428.JPG", "IMG_1429.JPG", "IMG_1430.JPG", "IMG_1431.JPG", "IMG_1432.JPG"],
  },
  {
    folder: "eighth",
    title: "Коттедж 160 м², пос. Соколово (Пятницкое ш.)",
    category: "Коттедж",
    type: "Приточно-вытяжная вентиляция",
    area: "160 м²",
    duration: "3 недели",
    summary:
      "Приточно-вытяжная вентиляция коттеджа 160 м²: установка с рекуперацией, скрытая разводка воздуховодов и пусконаладка системы под ключ.",
    files: ["IMG_1433.JPG", "IMG_1434.JPG", "IMG_1435.JPG", "IMG_1436.JPG", "IMG_1437.JPG", "IMG_1438.JPG", "IMG_1439.JPG", "IMG_1441.JPG", "IMG_1442.JPG"],
  },
  {
    folder: "ninth",
    title: "Коттедж 180 м² с охлаждением, пос. Соколово",
    category: "Коттедж",
    type: "Вентиляция с охлаждением",
    area: "180 м²",
    duration: "3,5 недели",
    summary:
      "Приточно-вытяжная вентиляция с охладителем в коттедже 180 м²: система подаёт свежий и уже охлаждённый воздух, объединяя вентиляцию и комфортное кондиционирование.",
    files: ["IMG_1440.JPG", "IMG_1443.JPG", "IMG_1444.JPG", "IMG_1445.JPG", "IMG_1446.JPG", "IMG_1447.JPG"],
  },
  {
    folder: "tenth",
    title: "Дом 278 м², г. Дмитров (пос. Орудьево)",
    category: "Дом",
    type: "Приточно-вытяжная вентиляция",
    area: "278 м²",
    duration: "4 недели",
    summary:
      "Монтаж приточно-вытяжной вентиляции в доме 278 м² в пос. Орудьево: установка с рекуперацией тепла, разводка воздуховодов по этажам и настройка комфортного микроклимата во всех помещениях.",
    files: ["photo_2026-08-02 18.10.46.jpeg", "photo_2026-08-02 18.10.48.jpeg", "photo_2026-08-02 18.10.49.jpeg", "photo_2026-08-02 18.10.50.jpeg", "photo_2026-08-02 18.10.56.jpeg", "photo_2026-08-02 18.10.59.jpeg", "photo_2026-08-02 18.11.00.jpeg", "photo_2026-08-02 18.11.02.jpeg", "photo_2026-08-02 18.11.03.jpeg", "photo_2026-08-02 18.11.04.jpeg"],
  },
  {
    folder: "eleventh",
    title: "Салон красоты «Спасские Ворота»",
    category: "Коммерческий объект",
    type: "Приточно-вытяжная вентиляция",
    area: "—",
    duration: "2,5 недели",
    summary:
      "Приточно-вытяжная вентиляция салона красоты «Спасские Ворота»: свежий воздух и удаление запахов в рабочих зонах, комфортный микроклимат для мастеров и клиентов.",
    files: ["photo_2026-08-02 18.16.19.jpeg", "photo_2026-08-02 18.16.21 (1).jpeg", "photo_2026-08-02 18.16.21.jpeg", "photo_2026-08-02 18.16.22.jpeg", "photo_2026-08-02 18.16.23.jpeg", "photo_2026-08-02 18.16.24.jpeg"],
  },
];

// Собираем полные пути к фото (кодируем пробелы и т.п.).
export const projects = raw.map((p, i) => {
  const photos = p.files.map((f) => encodeURI(`/objects/${p.folder}/${f}`));
  return {
    id: i + 1,
    title: p.title,
    category: p.category,
    type: p.type,
    area: p.area,
    duration: p.duration,
    summary: p.summary,
    photos, // все фото объекта (для галереи/лайтбокса)
    image: photos[0], // обложка
  };
});
